export default __webpack_public_path__ + "static/media/logo.64dcfa29.png";